import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _defineProperty from "babel-runtime/helpers/defineProperty";
import _JSON$stringify from "babel-runtime/core-js/json/stringify";
import _Promise from "babel-runtime/core-js/promise";


import axios from "axios";
import baseConfig from "./baseConfig";
import axiosConfig from "./axiosConfig";
import defineConfig from "./defineConfig";
import _storage from "@/tools/storage";
import { isObject, isString } from "util";
import Vue from "vue";
import store from "../vuex";
import Util from "@/oldCode/commonTools/util";

var fsEncrypt = require("../tools/libs/fs-enc");
window.fs = fsEncrypt;
var CancelToken = axios.CancelToken;

var vueInstance = function initVueInstance() {
  return new Vue();
}();
var timer = null;

Util.getUserIP(function (ip) {
  consoleLog("当前的客户端ip:" + ip);
  window.clientIp = ip;
  if (!!ip) {
    axiosConfig.$axioscfg.headers["X-Forwarded-For"] = ip;
  }
});

window.OSInfo = Util.getOSAndBrowser();

axios.interceptors.request.use(function (config) {
  config.id = Math.floor(Math.random() * 1000000);
  config.cancelToken = new CancelToken(function (c) {
    if (typeof window.ajaxQueue == "undefined") {
      window.ajaxQueue = [];
    }
    if (config.headers.isCancel != "noCancel") {
      window.ajaxQueue.push({ index: config.baseURL + "&" + config.id, cancel: c });
    }
  });

  config.headers = _.omit(config.headers, ["isCancel"]);
  config.headers.token = store.state.token;
  return config;
}, function (error) {
  return _Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  var config = response.config;
  var index = config.baseURL + "&" + config.id;

  if (window.ajaxQueue.find(function (v) {
    return v.index == index;
  }) != undefined) {
    _.remove(window.ajaxQueue, function (n) {
      return n.index == index;
    });
  }

  var bcfg = require("./baseConfig");
  if (bcfg.default.$basecfg.runtimeType == "record") {
    var reqData = JSON.parse(response.config.data);
    var service = reqData["REQUESTS"][0]["REQ_COMM_DATA"]["service"];
    delete reqData["REQUESTS"][0]["REQ_COMM_DATA"]["__RandomNo"];
    delete reqData["REQUESTS"][0]["REQ_COMM_DATA"]["OP_START_TIME"];
    delete reqData["REQUESTS"][0]["REQ_COMM_DATA"]["OPER_TIME"];
    reqData = _JSON$stringify(reqData);
    var respData = _JSON$stringify(response.data);

    var mockData = _storage.$storage.getJsonLocal("_MOCK_DATA");
    if (mockData) {
      if (!mockData.hasOwnProperty(service)) {
        mockData[service] = {};
      }
    } else {
      mockData = {};
      mockData[service] = {};
    }

    mockData[service][reqData] = respData;
    _storage.$storage.setLocal("_MOCK_DATA", mockData);
  }

  return response;
}, function axiosRetryInterceptor(err) {
  if (err.config) {
    var config = err.config;

    var index = config.baseURL + "&" + config.id;
    if (window.ajaxQueue.find(function (v) {
      return v.index == index;
    }) != undefined) {
      _.remove(window.ajaxQueue, function (n) {
        return n.index == index;
      });
    }
  }
  if (err.response) {
    switch (err.response.status) {
      case 401:
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          vm.alert(err.response.data.msg || "登录已过期");
          vm.$router.replace({ path: "/userLogin" });
        }, 1000);
        break;
    }
  } else if (err.message == "cancel") {
    return _Promise.reject(err);
  } else {
    var config = err.config;

    if (!config || !config.retry) return _Promise.reject(err);

    config.__retryCount = config.__retryCount || 0;

    if (config.__retryCount >= config.retry) {
      return _Promise.reject(err);
    }

    config.__retryCount += 1;

    var backoff = new _Promise(function (resolve) {
      setTimeout(function () {
        resolve();
      }, config.retryDelay || 1);
    });

    return backoff.then(function () {
      return axios(config);
    });
  }
});
var commonNotEditStatus = ["2", "11", "13", "14", "15", "16", "17", "18", "19"];
var configObject = {
  consts: function consts() {
    var baseUrl = baseConfig.$basecfg.httpConfig.baseUrl + ":" + baseConfig.$basecfg.httpConfig.proxyPort;
    return {
      SYS_CODE: {
        KDOP: "99",
        KUAS: "10",
        KSPB: "6",
        KFIS: "20",
        KGOB: "8",
        KGIS: "22",
        KFMS: "18",
        KBOS: "30",
        KOTC: "40",
        KSOT: "50",
        KCSS: "60",
        KCIF: "80" },
      REJECT_APPT_STATUS: ["3", "7", "10", "12"],
      COMMON_NO_UPDATE_APPT_STATUS: commonNotEditStatus,

      ACCEPT_NO_UPDATE_APPT_STATUS: commonNotEditStatus,
      IMGUPLOAD_NO_UPDATE_APPT_STATUS: commonNotEditStatus.concat(["4", "5", "6", "7", "8", "9", "10", "12"]),
      FORMPRINT_NO_UPDATE_APPT_STATUS: commonNotEditStatus,
      VIDEOWITNESS_NO_UPDATE_APPT_STATUS: commonNotEditStatus,
      FINISH_APPT_STATUS: ["13", "19"] };
  },
  getImgUrl: function getImgUrl(useLocalHost) {
    var _this = this;

    return new _Promise(function (resolve, reject) {
      _this.getImgConfig(true, useLocalHost).then(function (kidmUrl) {
        consoleLog("---------kidmUrl-----------", _JSON$stringify(kidmUrl));
        resolve({
          kidmDownload: kidmUrl + "/kjdp_kidmDownload",

          kidmNewImgClsDownload: kidmUrl + "/kjdp_kidmDownload",

          KidmServerUrl: kidmUrl + "/kjdp_ajax",

          kidmUpload: kidmUrl + "/kjdp_kidmUpload",

          kidmHtmlToPdfController: kidmUrl + "/kjdp_kidmHtmlToPdfController"
        });
      }).catch(function (err) {
        consoleLog("----------getImgUrl err----------", err);
        reject(err);
      });
    });
  },
  getImgConfig: function getImgConfig(useCache, useLocalHost) {
    var _this2 = this;

    return new _Promise(function (resolve, reject) {
      useCache = useCache != undefined ? useCache : true;
      var kidmUrl = "";
      var commonkidmUrl = _storage.$storage.getSession(defineConfig.$definecfg.KIDMURL);
      if (useCache && commonkidmUrl) {
        resolve(commonkidmUrl);
      } else if (useLocalHost) {
        resolve("http://10.97.24.163:8090/vtm");
      } else {
        var urlArr = ["kidm.server.url", "app.kidm.server.url"];
        _this2.K_Request("W0000128", {
          service: "W0000128",
          properties: urlArr.join(",")
        }).then(function (items) {
          if (items.Code == "0" && items.Data[0]) {
            kidmUrl = items.Data[0]["app.kidm.server.url"] ? items.Data[0]["app.kidm.server.url"] : items.Data[0]["kidm.server.url"];
            _storage.$storage.setSession(defineConfig.$definecfg.KIDMURL, kidmUrl);
            resolve(kidmUrl);
          } else {
            _storage.$storage.setSession(defineConfig.$definecfg.KIDMURL, kidmUrl);
            reject("获取影像地址失败" + items.Msg);
          }
        });
      }
    });
  },
  isQSJG: function isQSJG(qsVersion) {
    return baseConfig.$basecfg.qsVersion === qsVersion;
  },
  isLogin: function isLogin() {
    var loginstatus = _storage.$storage.getSession(defineConfig.$definecfg.USER_INFO);
    if (!loginstatus) {
      return 0;
    } else {
      return 1;
    }
  },

  isCustLogin: function isCustLogin() {
    var loginstatus = _storage.$storage.getSession(defineConfig.$definecfg.CUSTOMER_INFO);
    if (!loginstatus) {
      return false;
    } else {
      return true;
    }
  },

  getSysConfig: function getSysConfig(par_code, sys_code, PAR_NAME) {
    var _this3 = this;

    return new _Promise(function (resolve, reject) {
      var BUS_DATA = {};
      BUS_DATA["SYS_CODE"] = sys_code != undefined ? sys_code : "";
      BUS_DATA["PAR_CODE"] = par_code;
      BUS_DATA["PAR_NAME"] = PAR_NAME || "";
      resolve(_this3.K_RequestNoCancel("F0000099", BUS_DATA));
    });
  },

  getEncryptKey: function getEncryptKey(useCache) {
    var _this4 = this;

    return new _Promise(function (resolve, reject) {
      useCache = useCache != undefined ? useCache : true;
      var encKey = _storage.$storage.getSession(defineConfig.$definecfg.ENCRYPT_KEY);
      if (useCache && encKey) {
        resolve(encKey);
      } else {
        resolve(axios.post(_this4.consts().ENCRYPT_KEY_URL, {}, axiosConfig.$axioscfg));
      }
    });
  },

  getReqHead: function getReqHead(sReq) {
    var userInfo = _storage.$storage.getJsonSession(defineConfig.$definecfg.USER_INFO);
    return {
      F_OP_CODE: userInfo.USER_CODE || "",
      F_OP_ROLE: userInfo.USER_ROLE || "2",
      F_OP_BRANCH: userInfo.ORG_CODE || "",
      F_OP_SITE: userInfo.LOG_IP || "",
      F_SESSION: userInfo.USER_TICKET_INFO || "",
      F_OP_WAY: "1",
      F_OP_LANGUAGE: "1",
      F_OP_PROGRAM: sReq[this.consts().PROGRAM] || "",
      F_SERVER_ID: sReq[this.consts().SERVICE] || "",
      F_MSG_ID: sReq[this.consts().SERVICE] || "",

      F_CUST_ORG_CODE: sReq.F_CUST_ORG_CODE || ""
    };
  },

  makeJsonRequest: function makeJsonRequest(req) {
    var reqJson = [];
    var that = this;
    req = _.isArray(req) ? req : [req];
    _(req).forEach(function (n) {
      reqJson.push({
        REQ_MSG_HDR: that.getReqHead(n),
        REQ_COMM_DATA: n
      });
    });
    return _JSON$stringify({
      REQUESTS: reqJson
    });
  },

  makeXmlRequest: function makeXmlRequest(req) {
    return "<?xml version='1.0' encoding='UTF-8'?><requests><![CDATA[" + _JSON$stringify(_.isArray(req) ? {
      req: req
    } : {
      req: [req]
    }) + "]]></requests>";
  },

  resolveParam: function resolveParam(ansData) {
    var that = this,
        answers = ansData && ansData.ANSWERS;

    if (!answers || !answers.length) {
      return [];
    }

    return _.chain(answers).map(function (answer) {
      var ansMsgHdr = answer.ANS_MSG_HDR,
          ansCommData = answer.ANS_COMM_DATA;

      return {
        data: that.isSuccess(ansMsgHdr) && 2 === ansCommData.length && !ansCommData[0].BPM_DATA.length ? [[]].concat(ansCommData) : ansCommData,
        head: ansMsgHdr
      };
    }).value();
  },

  isSuccess: function isSuccess(head, extMsgCode) {
    var msgCodeArr = ["0", "100", "9010001", "-130011", "-404", "106192"].concat(_.isString(extMsgCode) ? extMsgCode.split(",") : _.isArray(extMsgCode) ? extMsgCode : []);

    if (!head || !head.MSG_CODE) {
      return false;
    }

    return -1 !== _.indexOf(msgCodeArr, head.MSG_CODE);
  },
  getErrMsg: function getErrMsg(error) {
    var _ERR_CODE_LIST;

    var ERR_CODE_LIST = (_ERR_CODE_LIST = {}, _defineProperty(_ERR_CODE_LIST, 400, "请求错误"), _defineProperty(_ERR_CODE_LIST, 401, "登录失效或在其他地方已登录"), _defineProperty(_ERR_CODE_LIST, 403, "拒绝访问"), _defineProperty(_ERR_CODE_LIST, 404, "请求地址出错"), _defineProperty(_ERR_CODE_LIST, 408, "请求超时"), _defineProperty(_ERR_CODE_LIST, 500, "服务器内部错误"), _defineProperty(_ERR_CODE_LIST, 501, "服务未实现"), _defineProperty(_ERR_CODE_LIST, 502, "网关错误"), _defineProperty(_ERR_CODE_LIST, 503, "服务不可用"), _defineProperty(_ERR_CODE_LIST, 504, "网关超时"), _defineProperty(_ERR_CODE_LIST, 505, "HTTP版本不受支持"), _ERR_CODE_LIST);
    if (error.response && !_.isEmpty(error.response)) {
      consoleLog("请求已发送，返回错误", error.response);
    } else {
      if (error.request && !_.isEmpty(error.request)) {
        consoleLog("请求已发出，但没有收到响应，返回错误", error.request);
        return {
          errCode: null,
          errMsg: "请求未响应，服务器异常！"
        };
      } else {
        return {
          errCode: null,
          errMsg: "请求异常，请重试"
        };
      }
    }
    var errCode = error.response.status;
    var errMsg = ERR_CODE_LIST[errCode];
    return {
      errCode: errCode,
      errMsg: errMsg ? "" + errMsg : error.message
    };
  },


  reportErrorLog: function reportErrorLog(busData) {
    var that = this;
    var USER_INFO = _storage.$storage.getJsonSession(defineConfig.$definecfg.USER_INFO) || {};
    busData = _Object$assign({}, {
      DEVICE_ID: USER_INFO.ORG_CODE + (baseConfig.$basecfg.isMobileFlag ? "-MOBILE-" : "-PC-") + USER_INFO.USER_CODE,
      PLATFORM: baseConfig.$basecfg.isMobileFlag ? "MOBILE" : "PC"
    }, busData);
    return new _Promise(function (resolve, reject) {
      return that.K_Request("F0000100", busData, true).then(function (res) {
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },

  K_Request: function K_Request(serviceId) {
    var busData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ignoreError = arguments[2];
    var noJudgeSuccess = arguments[3];

    var that = this;

    if (that.isQSJG(defineConfig.$definecfg.QSJGDM_CONST.GUOXIN)) {
      if (serviceId != "W0000097" && serviceId != "W0000098") {
        if (busData && busData.USER_TYPE && busData.USER_TYPE == "2") {
          busData.USER_TYPE = "1";
        }
      }
    }
    if (_.startsWith(serviceId, "Y") || _.startsWith(serviceId, "P") || _.startsWith(serviceId, "QS")) {
      busData = _.extend({}, busData, {
        "YZT_SERVICE_CODE": serviceId
      });
      serviceId = "F0000000";
    }

    busData.fxcReqId = this.getUuiD(1);
    return new _Promise(function (resolve, reject) {
      var currentServiceCode = {
        serviceId: serviceId,
        SERVICE_CODE: busData && busData.SERVICE_CODE
      };
      var axioscfg = _.cloneDeep(axiosConfig.$axioscfg);

      if (busData.allTimeout) {
        axioscfg.timeout = busData.allTimeout * 1000;
      }

      var data = fsEncrypt.encrypt(that.buildReqData(serviceId, busData));

      axios.post("fsapi/" + serviceId, data, axioscfg).then(function (ansData) {
        var ans = ansData.data.ANSWERS[0];
        var ans_head = ans.ANS_MSG_HDR;
        var ans_data = ans.ANS_COMM_DATA[0];
        var response = {
          "Code": ans_head.MSG_CODE,
          "Msg": ans_head.MSG_TEXT,
          "Data": ans_data
        };
        if (!noJudgeSuccess && !that.isSuccess(ans_head)) {
          consoleLog("\u8BF7\u6C42\u4E2D\u53F0\u63A5\u53E3\u62A5\u9519\uFF0CmsgCode\uFF1A" + ans_head.MSG_CODE + ",\u4E2D\u53F0\u63A5\u53E3\u53F7\uFF1A" + currentServiceCode.serviceId, busData);
          consoleLog(ans_head.MSG_TEXT);
          var msgError = that.transformErrMsg(ans_head.MSG_TEXT);
          reject(msgError);
          if (!ignoreError) {
            vueInstance.alert(msgError);
          }
        } else {
          resolve(response);
        }
      }).catch(function (error) {
        consoleLog("请求失败的接口信息：" + "错误接口的requestID为:" + busData.fxcReqId, _JSON$stringify(currentServiceCode));
        consoleLog("请求失败" + (_JSON$stringify(error) || error.stringify()));
        if (axios.isCancel(error)) {
          consoleLog("请求取消了");
        } else {
          var _that$getErrMsg = that.getErrMsg(error),
              errCode = _that$getErrMsg.errCode,
              errMsg = _that$getErrMsg.errMsg;

          consoleLog("\u8BF7\u6C42\u5931\u8D25\uFF0C\u9519\u8BEF\u4EE3\u7801=" + errCode + ";\u9519\u8BEF\u4FE1\u606F=" + errMsg + ";\u9519\u8BEF\u63A5\u53E3\u7684requestID\u4E3A:" + busData.fxcReqId);
          reject(errMsg);
          if (!ignoreError) {
            vueInstance.alert("请求失败：" + (errMsg || error.message) + ",id:" + busData.fxcReqId);
          }
        }
      });
    });
  },
  transformErrMsg: function transformErrMsg(msgError) {
    if (msgError.includes("原因:")) {
      var newMsg = msgError.split("原因:") && msgError.split("原因:")[1];
      return newMsg && newMsg.replace && newMsg.replace(/【/g, "").replace(/】/g, "") || newMsg;
    }

    if (msgError.includes("错误信息:")) {
      var _newMsg = msgError.split("错误信息:") && msgError.split("错误信息:")[1];
      return _newMsg && _newMsg.replace && _newMsg.replace(/【/g, "").replace(/】/g, "") || _newMsg;
    }
    if (msgError.includes("功能号") || msgError.includes("接口号") || msgError.includes("Could not send Message") || msgError.includes("KCBP") || msgError.includes("Unexpected EOF in prolog") || msgError.includes("Error reading XMLStreamReader")) {
      return "聚安一站通服务出错，请尝试重新提交。";
    } else if (msgError.includes("【业务影像类别查询调用失败,提示信息:【请求出错：0null】】")) {
      return "影像服务出错，请尝试重新提交。";
    } else {
      return msgError;
    }
  },

  K_RequestNoCancel: function K_RequestNoCancel(serviceId) {
    var busData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ignoreError = arguments[2];
    var noJudgeSuccess = arguments[3];

    var that = this;

    if (that.isQSJG(defineConfig.$definecfg.QSJGDM_CONST.GUOXIN)) {
      if (serviceId != "W0000097" && serviceId != "W0000098") {
        if (busData && busData.USER_TYPE && busData.USER_TYPE == "2") {
          busData.USER_TYPE = "1";
        }
      }
    }
    if (_.startsWith(serviceId, "Y") || _.startsWith(serviceId, "P") || _.startsWith(serviceId, "QS")) {
      busData = _.extend({}, busData, {
        "YZT_SERVICE_CODE": serviceId
      });
      serviceId = "F0000000";
    }

    busData.fxcReqId = this.getUuiD(1);
    return new _Promise(function (resolve, reject) {
      var currentServiceCode = {
        serviceId: serviceId,
        SERVICE_CODE: busData && busData.SERVICE_CODE
      };

      var data = fsEncrypt.encrypt(that.buildReqData(serviceId, busData));
      var axioscfgObj = _.cloneDeep(axiosConfig.$axioscfg);

      axioscfgObj.headers && (axioscfgObj.headers["isCancel"] = "noCancel");
      axios.post("fsapi/" + serviceId, data, axioscfgObj).then(function (ansData) {
        var ans = ansData.data.ANSWERS[0];
        var ans_head = ans.ANS_MSG_HDR;
        var ans_data = ans.ANS_COMM_DATA[0];
        var response = {
          "Code": ans_head.MSG_CODE,
          "Msg": ans_head.MSG_TEXT,
          "Data": ans_data
        };
        if (!noJudgeSuccess && !that.isSuccess(ans_head)) {
          consoleLog("\u8BF7\u6C42\u4E2D\u53F0\u63A5\u53E3\u62A5\u9519\uFF0CmsgCode\uFF1A" + ans_head.MSG_CODE + ",\u4E2D\u53F0\u63A5\u53E3\u53F7\uFF1A" + currentServiceCode.serviceId, busData);
          consoleLog(ans_head.MSG_TEXT);
          var msgError = that.transformErrMsg(ans_head.MSG_TEXT);
          reject(msgError);
          if (!ignoreError) {
            vueInstance.alert(msgError);
          }
        } else {
          resolve(response);
        }
      }).catch(function (error) {
        consoleLog("请求失败的接口信息：" + "错误接口的requestID为:" + busData.fxcReqId, _JSON$stringify(currentServiceCode));
        consoleLog("请求失败" + (_JSON$stringify(error) || error.stringify()));
        if (axios.isCancel(error)) {
          consoleLog("请求取消了");
        } else {
          var _that$getErrMsg2 = that.getErrMsg(error),
              errCode = _that$getErrMsg2.errCode,
              errMsg = _that$getErrMsg2.errMsg;

          consoleLog("\u8BF7\u6C42\u5931\u8D25\uFF0C\u9519\u8BEF\u4EE3\u7801=" + errCode + ";\u9519\u8BEF\u4FE1\u606F=" + errMsg + ";\u9519\u8BEF\u63A5\u53E3\u7684requestID\u4E3A:" + busData.fxcReqId);
          reject(errMsg);
          if (!ignoreError) {
            vueInstance.alert("请求失败：" + (errMsg || error.message) + ",id:" + busData.fxcReqId);
          }
        }
      });
    });
  },
  getUuiD: function getUuiD(randomLength) {
    var USER_INFO = _storage.$storage.getJsonSession(defineConfig.$definecfg.USER_INFO) || {};
    if (USER_INFO && USER_INFO.OP_CODE) {
      return window.btoa(USER_INFO.OP_CODE) + (baseConfig.$basecfg.isMobileFlag ? "-MOBILE-" : "-PC-") + Number(Math.random().toString().substr(2, randomLength) + Date.now()).toString(36);
    } else {
      return Number(Math.random().toString().substr(2, randomLength) + Date.now()).toString(36);
    }
  },

  K_Request_ALL: function K_Request_ALL(args) {
    return _Promise.all(args);
  },

  K_Request_Get: function K_Request_Get(url) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return axios.get(url, axiosConfig.$axioscfg);
  },
  K_Request_Post: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(url, data) {
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", axios.post(url, data, config));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function K_Request_Post(_x4, _x5) {
      return _ref.apply(this, arguments);
    }

    return K_Request_Post;
  }(),

  K_ImageRequest: function K_ImageRequest(param, url, singleMode) {
    var _this5 = this;

    var that = this;
    return new _Promise(function (resolve, reject) {
      var data = fsEncrypt.encrypt(_this5.makeJsonRequest(param), "888888");
      _this5.getImgUrl().then(function (imgConfig) {
        axios.post(imgConfig.KidmServerUrl + "?returnType=json", data, axiosConfig.$axioscfg).then(function (res) {
          var ansRet = _this5.resolveParam(res.data);
          if (ansRet.length) {
            resolve([ansRet[0].data, ansRet[0].head, ansRet]);
          } else {
            reject([ansRet[0].data, ansRet[0].head, ansRet]);
          }
        });
      }).catch(function (err) {
        reject(err);
      });
    });
  },

  buildReqData: function buildReqData(bus_code, bus_data) {
    var busi_data = isObject(bus_data) ? bus_data : {},
        REQ_MSG_HDR = {},
        userInfo = _storage.$storage.getJsonSession(defineConfig.$definecfg.USER_INFO),
        deviceInfo = {
      LIP: userInfo && userInfo.ipAddress,
      DEVICE_ID: window.OSInfo
    },
        custInfo = _storage.$storage.getJsonSession(defineConfig.$definecfg.CUSTOMER_INFO);
    busi_data["service"] = bus_code;
    busi_data["__RandomNo"] = new Date().getTime();
    if (bus_code == "F0000015") {
      busi_data["F_OP_SITE2"] = "PC;IIP=" + (deviceInfo.LIP || "NA") + ";IPORT=NA;LIP=" + (deviceInfo.LIP || "NA") + ";MAC=" + (deviceInfo.MAC || "NA") + ";HD=" + (deviceInfo.HD || "NA") + ";PCN=" + (deviceInfo.DEVICE_ID || "NA") + ";ICN=FXC";
    }
    REQ_MSG_HDR["F_OP_SITE"] = "" + deviceInfo.LIP;
    REQ_MSG_HDR["F_OP_SITE2"] = "PC;IIP=" + (deviceInfo.LIP || "NA") + ";IPORT=NA;LIP=" + (deviceInfo.LIP || "NA") + ";MAC=" + (deviceInfo.MAC || "NA") + ";HD=" + (deviceInfo.HD || "NA") + ";PCN=" + (deviceInfo.DEVICE_ID || "NA") + ";ICN=FXC";

    var REQ_COMM_DATA = busi_data;
    var request = {
      "REQUESTS": [{
        "REQ_MSG_HDR": REQ_MSG_HDR,
        "REQ_COMM_DATA": REQ_COMM_DATA
      }]
    };

    var res = _JSON$stringify(request);
    return res;
  },

  getSysDateTime: function getSysDateTime() {
    return this.K_Request("P9999997", {}).then(function (data) {
      return data && data.Data[0] && data.Data[0].DB_DATE + " " + data.Data[0].DB_TIME;
    });
  },

  getSysDate: function getSysDate() {
    return this.K_Request("P9999997", {}).then(function (data) {
      return data.Data[0] && data.Data[0].DB_DATE;
    });
  },

  getSysTime: function getSysTime() {
    return this.K_Request("P9999997", {}).then(function (data) {
      return data.Data[0] && data.Data[0].DB_TIME;
    });
  },

  isOpenAcctBiz: function isOpenAcctBiz(busiCode) {
    return this.isPersonOpenAcctBiz(busiCode) || this.isOrgOpenAcctBiz(busiCode) || this.isProOpenAcctBiz(busiCode);
  },

  isPersonOpenAcctBiz: function isPersonOpenAcctBiz(busiCode) {
    var openBiz = [""];
    return openBiz.indexOf(busiCode) != -1;
  },

  isOrgOpenAcctBiz: function isOrgOpenAcctBiz(busiCode) {
    var openBiz = ["QS138", "QS420"];
    return openBiz.indexOf(busiCode) != -1;
  },

  isProOpenAcctBiz: function isProOpenAcctBiz(busiCode) {
    var openBiz = ["QS139", "QS421"];
    return openBiz.indexOf(busiCode) != -1;
  },

  isNoPwdBiz: function isNoPwdBiz(busiCode) {
    var noPwdBizList = ["V0115", "V0130", "V0005", "V0133", "V0138", "V0149", "V0150", "V0087", "V0151"];
    return noPwdBizList.includes(busiCode);
  },

  getFlowModel: function getFlowModel() {
    if (this.isQSJG(defineConfig.$definecfg.QSJGDM_CONST.ZHONGTAI)) {
      if (baseConfig.$basecfg.isMobileFlag) {
        return "02";
      }
    } else if (this.isQSJG(defineConfig.$definecfg.QSJGDM_CONST.GUOXIN)) {
      if (baseConfig.$basecfg.isMobileFlag) {
        return "00";
      } else {
        return "02";
      }
    } else if (this.isQSJG(defineConfig.$definecfg.QSJGDM_CONST.ZHONGSHAN)) {
      if (baseConfig.$basecfg.isMobileFlag) {
        return "00";
      }
    } else if (this.isQSJG(defineConfig.$definecfg.QSJGDM_CONST.GUOTOU)) {
      return "01";
    } else {
      return "02";
    }
  },

  getYztChannel: function getYztChannel() {
    return "13";
  },
  K_LC_Request: function K_LC_Request(url, param) {
    var that = this;
    consoleLog("调用的时间节点: " + new Date().toLocaleString() + "：" + "调用的浪潮的双录的接口为:", url);
    var data = param || {};
    var baseUrl = "http://localhost:10327";
    var axioscfgObj = _Object$assign({}, axiosConfig.$axioscfg);
    axioscfgObj.headers && (axioscfgObj.headers["Content-Type"] = "application/x-www-form-urlencoded");
    axioscfgObj.baseURL && (axioscfgObj.baseURL = baseUrl);
    var get_req_arr = ["device/status", "device/preview/stop", "device/record/stop"];
    var errorFunc = function errorFunc(data) {
      that.reportDeviceErrorMsg({
        HARDWARE_CATEGORY: "2",
        ERROR_CODE: data.errcode,
        ERROR_CATEGORY: data.errcode,
        REMARK: url
      });
    };
    var reqErrFunc = function reqErrFunc(value) {
      ["file/text/read"].indexOf(value) == -1 && that.reportDeviceErrorMsg({
        HARDWARE_CATEGORY: "2",
        ERROR_CODE: "18",
        ERROR_CATEGORY: "18",
        REMARK: "未能连接上服务器" + url
      });
    };
    return new _Promise(function (resolve, reject) {
      if (get_req_arr.indexOf(url) > -1) {
        axios.get("/" + url, {
          url: "/",
          method: "GET",
          baseURL: baseUrl
        }).then(function (resdata) {
          if (resdata.status == 200) {
            if (resdata.data && resdata.errcode != "000") {
              errorFunc(resdata);
            }
            resolve(resdata.data);
          } else {
            reqErrFunc(url);
            reject({
              msg: "请求失败了"
            });
          }
        }).catch(function (err) {
          reqErrFunc(url);
          reject(err);
        });
      } else {
        axios.post("/" + url, data, axioscfgObj).then(function (slReData) {
          if (slReData.status == 200) {
            if (slReData.data && slReData.errcode != "000") {
              errorFunc(slReData);
            }
            resolve(slReData.data);
          } else {
            reqErrFunc(url);
            reject({
              msg: "请求失败了"
            });
          }
        }).catch(function (error) {
          reqErrFunc(url);
          reject({
            msg: "请求失败了"
          });
        });
      }
    });
  },
  K_KDXF_REQUEST: function K_KDXF_REQUEST(param) {

    var data = param || {};
    var baseUrl = "http://127.0.0.1:8769";
    var axioscfgObj = _Object$assign({}, axiosConfig.$axioscfg);

    axioscfgObj.baseURL && (axioscfgObj.baseURL = baseUrl);
    return new _Promise(function (resolve, reject) {
      axios.post("/", data, axioscfgObj).then(function (resdata) {
        if (resdata.status == 200) {
          resolve(resdata.data);
        } else {
          reject({
            msg: "请求失败了"
          });
        }
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};

var plugin = {
  install: function install(Vue) {
    Vue.syscfg = configObject;

    Vue.prototype.$syscfg = configObject;
  },

  $syscfg: configObject
};

export default plugin;
export var install = plugin.install;


//////////////////
// WEBPACK FOOTER
// ./src/config/sysConfig.js
// module id = 31
// module chunks = 2